import React, { ReactElement } from 'react';
import MenuInternal from '@mui/material/Menu';
import FormatService from '../../services/format-service';
import useStylesMenu from './menu.styles';

const Menu: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const ELEVATION_DEFAULT: number = 1;
  const ELEVATION_FLAT: number = 0;

  const {
    isFlat,
    isOpen,
    isHidden,
    isBordered,
    isListExtended,
    withShadow,
    withNoFocus,
    withListNoPadding,
    withNoPointerEvents,
    menuAnchor,
    className,
    menuClassName,
    listClassName,
    anchorOrigin,
    transformOrigin,
    onClick,
    onClose,
    onContextMenu,
    children,
  } = props;

  const { classes } = useStylesMenu();

  const isMenuOpen: boolean = Boolean(menuAnchor) && (isOpen !== undefined ? isOpen : true);

  const hiddenClassName: string | undefined = isHidden ? classes.menuHidden : undefined;
  const noPointerEventsClassName: string | undefined = withNoPointerEvents ? classes.menuNoPointerEvents : undefined;
  const menuBorderedClassName: string | undefined = isBordered ? classes.menuBorderedMenu : undefined;
  const listExtendedClassName: string | undefined = isListExtended ? classes.menuListExtended : undefined;
  const listNoPaddingClassName: string | undefined = withListNoPadding ? classes.menuListNoPadding : undefined;

  return (
    <MenuInternal
      keepMounted
      disableAutoFocus={withNoFocus}
      disableEnforceFocus={withNoFocus}
      disableRestoreFocus={withNoFocus}
      open={isMenuOpen}
      anchorEl={menuAnchor}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      onClick={onClick}
      onClose={onClose}
      onContextMenu={onContextMenu}
      classes={{
        root: FormatService.formatClassNames(hiddenClassName, noPointerEventsClassName, className),
        paper: FormatService.formatClassNames(menuBorderedClassName, menuClassName),
        list: FormatService.formatClassNames(listExtendedClassName, listNoPaddingClassName, listClassName),
      }}
      {
        ...(
          withNoFocus ? {
            autoFocus: false,
          } : {}
        )
      }
      {
        ...(
          (isFlat || withShadow) ? {
            elevation: withShadow ? ELEVATION_DEFAULT : ELEVATION_FLAT,
          } : {}
        )
      }
    >
      {
        withNoPointerEvents ? (
          <div className={classes.containerDefaultPointerEvents}>
            {children}
          </div>
        ) : children
      }
    </MenuInternal>
  );
});

export default Menu;
